module.exports = __webpack_public_path__ + "static/media/howItWork3.062e66d8.png";